var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlackDots(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33464 11.6654C4.25511 11.6654 5.0013 10.9192 5.0013 9.9987C5.0013 9.07822 4.25511 8.33203 3.33464 8.33203C2.41416 8.33203 1.66797 9.07822 1.66797 9.9987C1.66797 10.9192 2.41416 11.6654 3.33464 11.6654ZM10.0013 11.6654C10.9218 11.6654 11.668 10.9192 11.668 9.9987C11.668 9.07822 10.9218 8.33203 10.0013 8.33203C9.08083 8.33203 8.33464 9.07822 8.33464 9.9987C8.33464 10.9192 9.08083 11.6654 10.0013 11.6654ZM18.3346 9.9987C18.3346 10.9192 17.5884 11.6654 16.668 11.6654C15.7475 11.6654 15.0013 10.9192 15.0013 9.9987C15.0013 9.07822 15.7475 8.33203 16.668 8.33203C17.5884 8.33203 18.3346 9.07822 18.3346 9.9987Z",
    fill: "#222222"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackDots);
export default __webpack_public_path__ + "static/media/black-dots.025ad731b494de9d6d5686d7b6af3fea.svg";
export { ForwardRef as ReactComponent };